import { createChangeTierAction } from '../oauth_biller_support';

import { SLICE_NAME } from './constants';

export const changeTier = createChangeTierAction(SLICE_NAME);

export const downgradeTier = changeTier;
